import { Documentrelaties } from "./document-metadata";
import { Identifier } from "./identifier";

export interface DossierMetaData {
  pid?: string;
  titel?: string;
  dossierHouder?: Identifier;
  type?: DossierType;
  identificatiekenmerken: string[];
  creatieDatum?: string;
  omschrijving?: string;
  themas?: Identifier[];
  relaties?: Documentrelaties[];
}

export enum DossierType {
  vergadering = "vergadering",
  agendapunt = "agendapunt",
  "woo-verzoek" = "woo-verzoek",
  zaak = "zaak",
  advies = "advies",
  overig = "overig",
}
